import React from 'react'
import { Spinner } from '../../../utils/constants'

export default function SpinnerLoader() {
  return (
    <div className="text-center">
        <img src={Spinner} height="30px" width="30px" alt="" />
    </div>
  )
}
